var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Navbar')],1),_c('h1',[_vm._v("Payment Log")])])}
var staticRenderFns = []

export { render, staticRenderFns }